import TagManager from "react-gtm-module";
import { getProductBySku } from "./ProductUtils";
import { ecommerceCategories } from "./ProductCategoryUtils";

export function gtmSendEvent(event) {
  if (event !== null) {
    TagManager.dataLayer({
      dataLayer: event
    });
  }
}

export function itemFromProduct(sku, product, quantity, productCategories) {
  const isSample = product.sku !== sku;
  if (!productCategories) {
    console.error("itemFromProduct called without productCategories!");
  }
  const itemCategories = isSample
    ? ["samples"]
    : ecommerceCategories(product, productCategories);
  if (itemCategories.length === 0) {
    console.warn("itemFromProduct had no productCategories!");
    itemCategories.push("products");
  }
  const item = {
    item_id: sku,
    item_name: isSample ? "Sample: " + product.name : product.name,
    item_brand: product.brand,
    item_category: itemCategories[0],
    item_category2: itemCategories[1],
    item_category3: itemCategories[2],
    item_category4: itemCategories[3],
    item_category5: itemCategories[4],
    currency: product?.price?.currency,
    quantity,
    price:
      isSample || !product.price ? 0 : parseFloat(product.price?.basePrice) || 0
  };
  return JSON.parse(JSON.stringify(item)); // to remove undefined properties
}

export function beginCheckoutEventFromOrderData(
  orderData,
  products,
  productCategories
) {
  return {
    event: "begin_checkout",
    ecommerce: {
      coupon: orderData.campaignCode,
      items: orderData.cart.map(({ sku, amount }) => {
        const product = getProductBySku(products, sku);
        return itemFromProduct(sku, product, amount, productCategories);
      })
    }
  };
}

export function purchaseEventFromOrder(order, products, productCategories) {
  let currency;
  const items = order.lines.map(({ sku, amount }) => {
    const product = getProductBySku(products, sku);
    const item = itemFromProduct(sku, product, amount, productCategories);
    currency = item.currency;
    return item;
  });
  return {
    event: "purchase",
    ecommerce: {
      transaction_id: order.orderUuid,
      affiliation: "Bjelin Web",
      items,
      currency,
      value: parseFloat(order.totals.baseTotal),
      subtotal: parseFloat(order.totals.baseSubTotal),
      tax: parseFloat(order.totals.totalVat),
      shipping: parseFloat(order.totals.baseShippingFee),
      discount: parseFloat(order.totals.baseTotalDiscount),
      coupon: order.discountCode
    }
  };
}

export function gtmSendViewItem(product, productCategories) {
  gtmSendEvent({
    event: "view_item",
    ecommerce: {
      items: [
        itemFromProduct(product.sku, product, undefined, productCategories)
      ]
    }
  });
}

export function updateCartEvent(
  sku,
  product,
  oldAmount,
  newAmount,
  productCategories
) {
  const diff = newAmount - oldAmount;
  if (diff === 0) {
    return null;
  }
  return {
    event: diff > 0 ? "add_to_cart" : "remove_from_cart",
    ecommerce: {
      items: [itemFromProduct(sku, product, Math.abs(diff), productCategories)]
    }
  };
}

export function gtmSendUpdateCart(
  sku,
  product,
  oldAmount,
  newAmount,
  productCategories
) {
  const event = updateCartEvent(
    sku,
    product,
    oldAmount,
    newAmount,
    productCategories
  );
  gtmSendEvent(event);
}
